import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {GlobalUtils} from "../../utils/global-utils";
import {MenuUtil} from "../../utils/menu-utils";

@Component({
  selector: 'app-nous-contacter-shortcut',
  templateUrl: './nous-contacter-shortcut.component.html',
  styleUrls: ['./nous-contacter-shortcut.component.scss']
})
export class NousContacterShortcutComponent implements OnInit {

  constructor(private router : Router) { }

  get showContactShortcut() : boolean {
    let routerData = JSON.parse(GlobalUtils.getStorageItem("router"));
    return routerData.some(item => item.url === 'nous-contacter')
  };

  ngOnInit() {
  }

  goNousContacter() {
    this.router.navigateByUrl('nous-contacter')
  }

}
